var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_670:29759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1h175c3.314 0 6 2.69 6 6v42c0 3.31-2.686 6-6 6H7.5c-3.314 0-6-2.69-6-6V7c0-3.31 2.686-6 6-6Z",
    fill: "#0F1010",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.858 14.28c0 1.12-.28 2.1-.98 2.8-.84.84-1.82 1.26-3.08 1.26s-2.24-.42-3.08-1.26c-.84-.84-1.26-1.82-1.26-3.08s.42-2.24 1.26-3.08c.84-.84 1.82-1.26 3.08-1.26.56 0 1.12.14 1.68.42.56.28.98.56 1.26.98l-.7.7c-.56-.7-1.26-.98-2.24-.98-.84 0-1.68.28-2.24.98-.7.56-.98 1.4-.98 2.38s.28 1.82.98 2.38c.7.56 1.4.98 2.24.98.98 0 1.68-.28 2.38-.98.42-.42.7-.98.7-1.68h-3.08v-.98h4.06v.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.858 14.28c0 1.12-.28 2.1-.98 2.8-.84.84-1.82 1.26-3.08 1.26s-2.24-.42-3.08-1.26c-.84-.84-1.26-1.82-1.26-3.08s.42-2.24 1.26-3.08c.84-.84 1.82-1.26 3.08-1.26.56 0 1.12.14 1.68.42.56.28.98.56 1.26.98l-.7.7c-.56-.7-1.26-.98-2.24-.98-.84 0-1.68.28-2.24.98-.7.56-.98 1.4-.98 2.38s.28 1.82.98 2.38c.7.56 1.4.98 2.24.98.98 0 1.68-.28 2.38-.98.42-.42.7-.98.7-1.68h-3.08v-.98h4.06v.42Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3 10.78h-3.78v2.66h3.5v.98h-3.5v2.66h3.78v1.12h-4.9V9.8h4.9v.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3 10.78h-3.78v2.66h3.5v.98h-3.5v2.66h3.78v1.12h-4.9V9.8h4.9v.98Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92 18.2H76.8v-7.42h-2.38V9.8h5.88v.98h-2.38v7.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92 18.2H76.8v-7.42h-2.38V9.8h5.88v.98h-2.38v7.42Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.358 18.2V9.8h1.12v8.4h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.358 18.2V9.8h1.12v8.4h-1.12Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.242 18.2h-1.12v-7.42h-2.38V9.8h5.74v.98h-2.38v7.42h.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.242 18.2h-1.12v-7.42h-2.38V9.8h5.74v.98h-2.38v7.42h.14Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.241 14c0-.98.42-1.82.98-2.38.56-.7 1.4-.98 2.24-.98.84 0 1.68.42 2.24.98.7.56.98 1.4.98 2.38s-.42 1.82-.98 2.38c-.56.7-1.4.98-2.24.98-.84 0-1.68-.42-2.24-.98-.7-.56-.98-1.4-.98-2.38Zm7.56 0c0-1.26-.42-2.24-1.26-3.08-.84-.84-1.82-1.26-3.08-1.26s-2.24.42-3.08 1.26c-.84.84-1.26 1.82-1.26 3.08s.42 2.24 1.26 3.08c.84.84 1.82 1.26 3.08 1.26s2.24-.42 3.08-1.26c.84-.84 1.26-1.82 1.26-3.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.241 14c0-.98.42-1.82.98-2.38.56-.7 1.4-.98 2.24-.98.84 0 1.68.42 2.24.98.7.56.98 1.4.98 2.38s-.42 1.82-.98 2.38c-.56.7-1.4.98-2.24.98-.84 0-1.68-.42-2.24-.98-.7-.56-.98-1.4-.98-2.38Zm7.56 0c0-1.26-.42-2.24-1.26-3.08-.84-.84-1.82-1.26-3.08-1.26s-2.24.42-3.08 1.26c-.84.84-1.26 1.82-1.26 3.08s.42 2.24 1.26 3.08c.84.84 1.82 1.26 3.08 1.26s2.24-.42 3.08-1.26c.84-.84 1.26-1.82 1.26-3.08Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.337 18.2V9.8h1.26l4.06 6.58V9.8h1.12v8.4h-1.12l-4.34-6.86v6.86h-.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.337 18.2V9.8h1.26l4.06 6.58V9.8h1.12v8.4h-1.12l-4.34-6.86v6.86h-.98Z",
    stroke: "#fff",
    strokeWidth: 0.583,
    strokeMiterlimit: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.162 24.5h2.66V42h-2.66V24.5Zm26.32 6.3-7.14 16.52h-2.66l2.66-5.88-4.62-10.64h2.8l3.08 7.56h.14l2.94-7.56h2.8Zm-14.42 6.44c-.7-.28-1.26-.56-2.38-.56-1.26 0-2.8.42-2.8 1.82 0 1.12 1.26 1.54 2.1 1.54 1.4 0 2.8-1.12 3.08-2.8Zm2.8-1.96V42h-2.52v-1.4h-.14c-.7.84-1.54 1.68-3.36 1.68-2.24 0-4.34-1.54-4.34-3.92 0-2.52 2.52-3.92 5.04-3.92 1.12 0 2.24.42 2.66.7V35c-.14-1.4-1.4-2.24-2.8-2.24-.98 0-1.82.28-2.38 1.26l-2.38-.98c.7-1.82 2.66-2.66 4.62-2.66 2.94 0 5.32 1.82 5.6 4.9Zm-18.62-5.46c0-1.26-1.12-2.94-3.08-2.94h-3.78v6.02h3.78c1.82 0 2.94-1.54 3.08-3.08Zm2.52.14c0 3.36-2.8 5.46-5.74 5.46h-3.64V42h-2.66V24.5h6.3c2.94 0 5.74 2.1 5.74 5.46Zm-36.68 6.44c0-2.1-1.4-3.64-3.22-3.64-1.82 0-3.36 1.54-3.36 3.64s1.54 3.64 3.36 3.64c1.82 0 3.22-1.54 3.22-3.64Zm-.14-5.6h2.52v10.64c0 4.34-2.52 6.16-5.6 6.16-2.94 0-4.62-1.96-5.32-3.5l2.24-.98c.28.98 1.4 2.1 2.94 2.1 1.96 0 3.22-1.26 3.22-3.5v-.84h-.14c-.56.7-1.68 1.4-3.08 1.4-3.08 0-5.74-2.52-5.74-5.88s2.8-6.02 5.74-6.02c1.4 0 2.52.7 3.22 1.4v-.98Zm4.2-6.3h2.66V42h-2.66V24.5Zm11.9 9.52c-.28-.7-1.26-1.26-2.24-1.26-1.26 0-3.08 1.26-3.08 3.5l5.32-2.24Zm3.08.98-7.98 3.36c.7 1.26 1.54 1.82 2.94 1.82s2.24-.7 2.94-1.68l1.96 1.4c-.56.98-2.24 2.66-4.9 2.66-3.36 0-5.88-2.66-5.88-6.02 0-3.64 2.52-6.02 5.6-6.02 3.08 0 4.48 2.38 5.04 3.78l.28.7Zm-55.16-2.66c.14.42.14.98.14 1.54 0 1.82-.56 4.2-2.24 5.88-1.68 1.82-3.64 2.66-6.44 2.66-5.04 0-9.38-4.2-9.38-9.24s4.34-9.24 9.38-9.24c2.8 0 4.76 1.12 6.3 2.52l-1.82 1.82c-1.12-.98-2.66-1.82-4.62-1.82-3.64 0-6.58 2.94-6.58 6.72s2.8 6.72 6.58 6.72c2.38 0 3.78-.98 4.62-1.82.7-.7 1.26-1.82 1.4-3.22h-6.02v-2.52h8.68Zm10.22 4.06c0-2.24-1.54-3.64-3.36-3.64-1.82 0-3.36 1.54-3.36 3.64s1.54 3.64 3.36 3.64c1.82 0 3.36-1.54 3.36-3.64Zm2.66.14c0 3.5-2.66 6.02-6.02 6.02-3.36 0-6.02-2.66-6.02-6.02 0-3.5 2.66-6.02 6.02-6.02 3.36 0 6.02 2.38 6.02 6.02Zm10.36-.14c0-2.24-1.54-3.64-3.36-3.64-1.82 0-3.36 1.54-3.36 3.64s1.54 3.64 3.36 3.64c1.82 0 3.36-1.54 3.36-3.64Zm2.66.14c0 3.5-2.66 6.02-6.02 6.02-3.36 0-6.02-2.66-6.02-6.02 0-3.5 2.66-6.02 6.02-6.02 3.36 0 6.02 2.38 6.02 6.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.058 10.5c-.42.42-.7 1.12-.7 1.96V43.4c0 .84.28 1.54.7 1.96l.14.14 17.36-17.36v-.28l-17.5-17.36Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.299 34.02-5.74-5.74v-.42l5.74-5.74.14.14 6.86 3.92c1.96 1.12 1.96 2.94 0 4.06l-7 3.78Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.439 33.88 32.559 28l-17.5 17.5c.7.7 1.68.7 2.94.14l20.44-11.76Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.439 22.124-20.44-11.62c-1.26-.7-2.24-.56-2.94.14l17.5 17.36 5.88-5.88Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m18 10.639 27.3 15.54c.84.56 1.4 1.12 1.4 1.82 0-.7-.42-1.4-1.4-1.96L18 10.499c-1.96-1.12-3.5-.14-3.5 2.1v.14c0-2.24 1.54-3.22 3.5-2.1Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.8,
    x2: 5.02,
    y1: 8.71,
    y2: 25.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 33.83,
    x2: 9.64,
    y1: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 24.83,
    x2: 2.07,
    y1: 22.3,
    y2: 45.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 7.3,
    x2: 17.46,
    y1: 0.18,
    y2: 10.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.da084ed3efb253e8a704c1c4b1eaf7aa.svg";
export { ForwardRef as ReactComponent };